import React, { useState } from "react";
import { BackButton, InputWithLabel } from "../../components/micro";
import { HouseSearch } from "../../assets/svg/AllSvg";
import { useNavigate } from "react-router-dom";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import ConfirmationModel from "../../commons/ConfirmationModel";
import { useDispatch } from "react-redux";
import { addBillingInformation } from "../../redux/billingSubscriptions/slice";

const BillingInformation = () => {
  const [isConfirm, setIsConfirm] = useState(false);
  const [values, setValues] = useState({});
  const [isLoad, setIsLoad] = useState(false);
  const User_Id = sessionStorage.getItem("user_Id");
  const navigate = useNavigate();
  const dispatch = useDispatch();

  // Handle Save
  const handleSave = (values) => {
    setIsLoad(true);
    dispatch(addBillingInformation({ ...values, user_id: User_Id })).then(
      (res) => {
        setIsLoad(false);
        if (res.type === "addBillingInformation/fulfilled") {
          navigate("/billing-subscriptions");
        }
      }
    );
  };

  return (
    <>
      {/* Page Header */}
      <div>
        <BackButton
          onClick={() => navigate("/billing-subscriptions")}
          className={"mb-3"}
        />
        <div className="flex items-center space-x-3 border-b-2 pb-5 mb-5">
          <h1 className="xl:text-3xl lg:text-2xl sm:text-xl text-base font-ebGaramond">
            My Billing Information
          </h1>
          <div className="max-w-14 w-full">
            <HouseSearch className="w-full" />
          </div>
        </div>
        <Formik
          enableReinitialize={true}
          initialValues={{
            address: "",
            city: "",
            state: "",
            zipcode: "",
            email: "",
            phone: "",
          }}
          validationSchema={Yup.object().shape({
            address: Yup.string().required("Please Enter Address"),
            city: Yup.string(),
            state: Yup.string().required("Please Enter State"),
            zipcode: Yup.string().required("Please Enter ZIP Code"),
            email: Yup.string().required("Please Enter Email"),
            phone: Yup.string()
              .required("Please Enter Mobile")
              .matches(/^\d{8,15}$/, "Mobile number must be 8-15 digits")
              .min(8, "Mobile number must be at least 8 digits")
              .max(15, "Mobile number must be at most 15 digits"),
          })}
          onSubmit={(values) => {
            setValues(values);
            setIsConfirm(true);
          }}
        >
          {({
            values,
            errors,
            touched,
            handleBlur,
            handleChange,
            handleSubmit,
          }) => (
            <Form className="w-full" onSubmit={handleSubmit}>
              <div className="space-y-3 mb-6">
                <InputWithLabel
                  label={"Address*"}
                  type={"text"}
                  className={
                    errors.address && touched.address
                      ? ` input-error `
                      : ` border `
                  }
                  idFromName="address"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.address}
                  errors={errors.address && touched.address}
                  errorsText={errors.address}
                />
                <div className="grid grid-cols-3 gap-3">
                  <InputWithLabel
                    label={"City"}
                    type={"text"}
                    className={
                      errors.city && touched.city ? ` input-error ` : ` border `
                    }
                    idFromName="city"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.city}
                    errors={errors.city && touched.city}
                    errorsText={errors.city}
                  />
                  <InputWithLabel
                    label={"State*"}
                    type={"text"}
                    className={
                      errors.state && touched.state
                        ? ` input-error `
                        : ` border `
                    }
                    idFromName="state"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.state}
                    errors={errors.state && touched.state}
                    errorsText={errors.state}
                  />
                  <InputWithLabel
                    label={"ZIP Code*"}
                    type={"number"}
                    className={
                      errors.zipcode && touched.zipcode
                        ? ` input-error `
                        : ` border `
                    }
                    idFromName="zipcode"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.zipcode}
                    errors={errors.zipcode && touched.zipcode}
                    errorsText={errors.zipcode}
                  />
                </div>
                <div className="grid grid-cols-2 gap-3">
                  <InputWithLabel
                    label={"Email"}
                    type={"email"}
                    className={
                      errors.email && touched.email
                        ? ` input-error `
                        : ` border `
                    }
                    idFromName="email"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.email}
                    errors={errors.email && touched.email}
                    errorsText={errors.email}
                  />
                  <InputWithLabel
                    label={"Phone"}
                    type={"phone"}
                    className={
                      errors.phone && touched.phone
                        ? ` input-error `
                        : ` border `
                    }
                    idFromName="phone"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.phone}
                    errors={errors.phone && touched.phone}
                    errorsText={errors.phone}
                  />
                </div>
              </div>

              <div className="flex gap-4">
                <button
                  type="button"
                  className="btn-outline uppercase"
                  onClick={() => navigate("/billing-subscriptions")}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  disabled={isLoad}
                  className={`${
                    isLoad ? "btn-outline-disabled" : "btn-theme"
                  } uppercase`}
                >
                  {isLoad ? "Loading" : "Save"}
                </button>
              </div>
            </Form>
          )}
        </Formik>
      </div>
      {/* Confirmation Model */}
      {isConfirm && (
        <ConfirmationModel
          isLoading={isLoad}
          onClose={() => setIsConfirm(false)}
          onConfirm={() => handleSave(values)}
          confirmText={"Save My Billing Information"}
        />
      )}
    </>
  );
};

export default BillingInformation;
